import script from "./AppNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNav.vue?vue&type=script&setup=true&lang=js"

import "./AppNav.vue?vue&type=style&index=0&id=3471c7f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3471c7f6"]])

export default __exports__